var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyvault(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 383,
    height: 331,
    viewBox: "0 0 383 331",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4648_45376",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 383,
    height: 331
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0327148,
    y: 0.796875,
    width: 382.6,
    height: 329.508,
    rx: 16,
    fill: "url(#paint0_linear_4648_45376)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4648_45376)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("rect", {
    x: -16.75,
    y: -0.84375,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.25,
    y: -0.84375,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.25,
    y: -0.84375,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_4648_45376)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 99.5,
    y: -1.59375,
    width: 40,
    height: 40,
    fill: "#1784B6",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.25,
    y: -0.84375,
    width: 38.5,
    height: 38.5,
    stroke: "#1C9FDA",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 139.25,
    y: -0.84375,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.25,
    y: -0.84375,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_4648_45376)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 216.5,
    y: -1.59375,
    width: 40,
    height: 40,
    fill: "#1784B6",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.25,
    y: -0.84375,
    width: 38.5,
    height: 38.5,
    stroke: "#1C9FDA",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 256.25,
    y: -0.84375,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.25,
    y: -0.84375,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.25,
    y: -0.84375,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: -17.5,
    y: 37.4062,
    width: 40,
    height: 40,
    fill: "#E2E7F0",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 37.4062,
    width: 40,
    height: 40,
    fill: "#E2E7F0",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.5,
    y: 37.4062,
    width: 40,
    height: 40,
    fill: "#E2E7F0",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.5,
    y: 37.4062,
    width: 40,
    height: 40,
    fill: "#E2E7F0",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.5,
    y: 37.4062,
    width: 40,
    height: 40,
    fill: "#E2E7F0",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.5,
    y: 37.4062,
    width: 40,
    height: 40,
    fill: "#E2E7F0",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.25,
    y: 38.1562,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.25,
    y: 38.1562,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_4648_45376)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 294.5,
    y: 37.4062,
    width: 40,
    height: 40,
    fill: "#1784B6",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.25,
    y: 38.1562,
    width: 38.5,
    height: 38.5,
    stroke: "#1C9FDA",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 334.25,
    y: 38.1562,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.25,
    y: 38.1562,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_4648_45376)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 372.5,
    y: 37.4062,
    width: 40,
    height: 40,
    fill: "#1784B6",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.25,
    y: 38.1562,
    width: 38.5,
    height: 38.5,
    stroke: "#1C9FDA",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: -16.75,
    y: 77.1562,
    width: 38.5,
    height: 38.5,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.25,
    y: 77.1562,
    width: 38.5,
    height: 38.5,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.25,
    y: 77.1562,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_4648_45376)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.5,
    y: 76.4062,
    width: 40,
    height: 40,
    fill: "#1784B6",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.25,
    y: 77.1562,
    width: 38.5,
    height: 38.5,
    stroke: "#1C9FDA",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 100.25,
    y: 77.1562,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.25,
    y: 77.1562,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_4648_45376)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 138.5,
    y: 76.4062,
    width: 40,
    height: 40,
    fill: "#1784B6",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.25,
    y: 77.1562,
    width: 38.5,
    height: 38.5,
    stroke: "#1C9FDA",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 217.25,
    y: 77.1562,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.25,
    y: 77.1562,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.25,
    y: 77.1562,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.25,
    y: 116.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.25,
    y: 116.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.25,
    y: 116.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.25,
    y: 116.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.25,
    y: 116.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.25,
    y: 116.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_4648_45376)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.5,
    y: 154.406,
    width: 40,
    height: 40,
    fill: "#1784B6",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.25,
    y: 155.156,
    width: 38.5,
    height: 38.5,
    stroke: "#1C9FDA",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 100.25,
    y: 155.156,
    width: 38.5,
    height: 38.5,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.25,
    y: 155.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.25,
    y: 155.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.25,
    y: 155.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.25,
    y: 155.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: -16.75,
    y: 194.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.5,
    y: 193.406,
    width: 40,
    height: 40,
    fill: "#E2E7F0",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.25,
    y: 194.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.25,
    y: 194.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.25,
    y: 194.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.25,
    y: 194.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.25,
    y: 194.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.25,
    y: 194.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.25,
    y: 194.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.25,
    y: 233.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.25,
    y: 233.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.25,
    y: 233.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.25,
    y: 233.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.25,
    y: 233.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.25,
    y: 233.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.25,
    y: 233.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.25,
    y: 233.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.25,
    y: 233.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.25,
    y: 233.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: -16.75,
    y: 272.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.25,
    y: 272.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.25,
    y: 272.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.25,
    y: 272.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.25,
    y: 272.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.25,
    y: 272.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.25,
    y: 272.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.25,
    y: 272.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.25,
    y: 272.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.25,
    y: 272.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.25,
    y: 272.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: -16.75,
    y: 311.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.25,
    y: 311.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.25,
    y: 311.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.25,
    y: 311.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.25,
    y: 311.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.25,
    y: 311.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.25,
    y: 311.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.25,
    y: 311.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.25,
    y: 311.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.25,
    y: 311.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.25,
    y: 311.156,
    width: 38.5,
    height: 38.5,
    fill: "#E2E7F0",
    fillOpacity: 0.3,
    stroke: "#E2E7F0",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 48.6636,
    y: 48.707,
    width: 288.015,
    height: 271.598,
    rx: 16,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.9402,
    y: 59.6836,
    width: 266.01,
    height: 137.698,
    rx: 8,
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.9238,
    y: 158.191,
    width: 79.807,
    height: 31.2612,
    rx: 4,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.9404,
    y: 209.059,
    width: 109.776,
    height: 8.49224,
    rx: 4,
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.9404,
    y: 280.18,
    width: 109.776,
    height: 27.2743,
    rx: 8,
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.175,
    y: 280.18,
    width: 109.776,
    height: 27.2743,
    rx: 8,
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.9404,
    y: 226.043,
    width: 77.9302,
    height: 8.49224,
    rx: 4,
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.021,
    y: 209.059,
    width: 77.9302,
    height: 8.49224,
    rx: 4,
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.021,
    y: 226.043,
    width: 77.9302,
    height: 8.49224,
    rx: 4,
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.021,
    y: 243.027,
    width: 77.9302,
    height: 8.49224,
    rx: 4,
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.9404,
    y: 243.027,
    width: 77.9302,
    height: 8.49224,
    rx: 4,
    fill: "#E7E7E7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4648_45376",
    x: 97.5,
    y: -3.59375,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_4648_45376"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_4648_45376",
    x: 214.5,
    y: -3.59375,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_4648_45376"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_4648_45376",
    x: 292.5,
    y: 35.4062,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_4648_45376"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_4648_45376",
    x: 370.5,
    y: 35.4062,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_4648_45376"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_4648_45376",
    x: 58.5,
    y: 74.4062,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_4648_45376"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_4648_45376",
    x: 136.5,
    y: 74.4062,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_4648_45376"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_4648_45376",
    x: 58.5,
    y: 152.406,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_4648_45376"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4648_45376",
    x1: 191.333,
    y1: 208.213,
    x2: 191.333,
    y2: 330.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyvault);
export default __webpack_public_path__ + "static/media/emptyvault.55c6769e4a52c6452a646e743af04260.svg";
export { ForwardRef as ReactComponent };